var Ractive = require('ractive');
var component = module;

	component.exports = {
		onrender: function (options) {
			var self = this;
			var fId = self.get('id');
			var meta;
			var getRefVal = function(iValue){
				var fValue = iValue.toString();
				var fRequest = {
					Name: "Reference", 
					Payload: {
						value: fValue,
						referencesqlid: meta.ReferenceSqlId
					}
				};
				self.cmd.Data(self, fRequest, function(oData){
					if(oData){
						if(oData.Status){
							self.set("refvalue", oData.Data.Caption);
						}else{
							if(oData.Error){
								self.set("refvalue", oData.Error);
							}
							toastr.error("Error", oData.Error);							
						}
					}
				});
			}

			if(self.get('mandatory')){
				self.set('regex', "^(?!\s*$).+");
			}

			if (meta = self.get('Meta')) {
				//console.log(meta);
				if (meta.Control) {
					self.set('type', meta.Control.toLowerCase());
				} else {
					if (meta.DetailControl) {
						self.set('type', meta.DetailControl.toLowerCase());
					}
				}
				if (meta.DetailCaption) {
					self.set('title', meta.DetailCaption);
				} else {
					if (meta.Caption){
						self.set('title', meta.Caption);
					}
				}
				if (meta.Description) self.set('placeholder', meta.Description);
				if (meta.MandatoryRegEx){
					self.set('regex', meta.MandatoryRegEx);
				}else{
					if(meta.DetailMandatory){
						self.set('regex', "^(?!\s*$).+");
					}					
				}
				//if(meta.Id) self.set('id', (fId=meta.sysuid));
				if (meta.Readonly){
					self.set('readonly', meta.Readonly);
				}
			}
			if ((!fId) || typeof (fId) === "undefined" || fId == "") {
				fId = Client.getShort(8);
				self.set('id', fId);
			}
			self.set('showTitle', (self.get('title') != ''));

			switch (self.get('type')) {
				case 'text':
					//self.set('class', 'form-control');
					break;
				case 'date':
					/* $('#'+fId).datepicker({
							format: 'dd.mm.yyyy',
							language: "rs-latin",
							orientation: "bottom auto",
							autoclose: true
					}).on("changeDate", function(e) {
						var d = new Date(e.date);//.toISOString().slice(0,10);
						month = '' + (d.getMonth() + 1),
						day = '' + d.getDate(),
						year = d.getFullYear();

						if (month.length < 2) month = '0' + month;
						if (day.length < 2) day = '0' + day;

						fDate = [year, month, day].join('-');
						self.set('value', fDate);
						//console.log(todayDate, e);
					}); */
					break;
				case 'number':
					break;
				case 'checkbox':
					break;
				case 'memo':
					break;
				case 'file':
					setTimeout(function () {
						//var fEl = document.getElementById('dzone');
						//console.log('dropzone2', fEl);
						$(".dropzone").dropzone({
							url: Global.Server.REST,
							maxFiles: 1,
							maxFilesize: 5,
							// acceptedFiles: '*/*',
							addRemoveLinks: true,
							accept: function (file, response) {
								console.log('File accept', file);
								reader = new FileReader();
								reader.onload = handleReaderLoad;
								reader.readAsDataURL(file);
								file.accepted = false;
								//response();
								function handleReaderLoad(e) {
									var re = /(?:\.([^.]+))?$/;
									var ext = re.exec(file.name)[1];
									var fFileName = Client.getGuid() + '.' + ext;
									var fRow = {
										Action: "upload",
										FileUID: fFileName,
										Caption: file.name,
										FileName: file.name,
										RealFileName: fFileName,
										RealLocation: '',
										FileType: file.type,
										FileSize: file.size,
										FileData: e.target.result
									};
									self.set('value', fRow.FileUID);
									self.set('file', fRow);
									console.log('File handleReaderLoad', fRow);
									//console.log('File handleReaderLoad', e.target.result);
									/*
									$.post(Global.Server.REST, fRow, function (oData) {
											if (oData.status=="true") {
												toastr.success("Uspešno", 'Snimljeno ' + oData.filename, {"timeOut": "500"});
												self.set('value', fRow.FileUID);
											}	else {
												toastr.error("Greska", oData.message, {"timeOut": "500"});
												//success(ffile, data)
											}
									}, "json").fail( function() { toastr.error("Error", 'Network error'); });
									*/
								}
							},
							removedfile: function (file) {
								self.set('value', '');
								return true;
							}
						});

					}, 200);
					//return;


					// var dzone = self.nodes.dzone;
					// var dzdocArray = [];
					// Dropzone = require('dropzone');
					// Dropzone.autoDiscover = false;
					// var myDropzone = new Dropzone(".dropzone", { 
					// 	url: "/rest.php?action=uploadfilefrombase64",

					// 	accept: function(file, done){
					// 		reader = new FileReader();
					// 		reader.onload = handleReaderLoad;
					// 		reader.readAsDataURL(file);
					// 		function handleReaderLoad(evt) {
					// 			var idx = file.name.lastIndexOf('.') + 1
					// 			var ext = file.name.substr(idx);

					// 			var name = file.name.substr(0, file.name.lastIndexOf('.')) + '-' + generateUUID();
					// 			file.name = name + '.' + ext;
					// 			upload('', evt.target.result, ext);

					// 			file.accepted = true;
					// 			myDropzone.success = true;
					// 			myDropzone.emit("success", file);
					// 		}
					// 	},
					// });

					/* 					$('.dropify').dropify({
													messages: {
															'default': 'Drag and drop a file here or click',
															'replace': 'Drag and drop or click to replace',
															'remove':  'Remove',
															'error':   'Ooops, something wrong happended.'
													}
											}); */
					break;
				case 'image':
					console.log('DDD #', fId);
					$('#' + fId).click(function () {
						$(this).attr("value", "");
					});
					$('#' + fId).change(function () {
						var fFiles = $(this).prop('files');
						var file = fFiles[0];
						console.log('f', file);
						var re = /(?:\.([^.]+))?$/;
						var ext = re.exec(file.name)[1];
						var fFileName = Client.getGuid() + '.' + ext;

						var reader = new FileReader();
						reader.readAsDataURL(fFiles[0]);
						reader.onload = function () {
							//console.log(reader.result);
							var fRow = {
								Action: "upload",
								FileUID: fFileName,
								Caption: file.name,
								FileName: file.name,
								RealFileName: fFileName,
								RealLocation: '',
								FileType: file.type,
								FileSize: file.size,
								FileData: reader.result
							};
							if ((Global.Behavior) && (Global.Behavior.echoLevel)) {
								fRow.debug = Global.Behavior.echoLevel;
							}
							$.post(Global.Server.REST, fRow, function (oData) {
								if (oData.status == "true") {
									//toastr.success("Uspe&#353;no", 'Obra&#273;eno ' + file.name, {"timeOut": "500"});
									self.set('value', fFileName);
								} else {
									toastr.error("Neuspe&#353;o", oData.message, { "timeOut": "500" });
								}
							}, "json").fail(function () { toastr.error("Error", 'Network error'); });
						};
						reader.onerror = function (error) {
							toastr.error("Neuspe&#353;o", error, { "timeOut": "500" });
							console.log('Error: ', error);
						};
					});
					break;
			}
			self.on('doImageDelete', function () {
				self.set('value', '');
				$('#' + fId).click(function () {
					$(this).attr("value", "");
				});
				$('#' + fId).change(function () {
					var fFiles = $(this).prop('files');
					var file = fFiles[0];
					console.log('f', file);
					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(file.name)[1];
					var fFileName = Client.getGuid() + '.' + ext;

					var reader = new FileReader();
					reader.readAsDataURL(fFiles[0]);
					reader.onload = function () {
						//console.log(reader.result);
						var fRow = {
							Action: "upload",
							FileUID: fFileName,
							Caption: file.name,
							FileName: file.name,
							RealFileName: fFileName,
							RealLocation: '',
							FileType: file.type,
							FileSize: file.size,
							FileData: reader.result
						};
						if ((Global.Behavior) && (Global.Behavior.echoLevel)) {
							fRow.debug = Global.Behavior.echoLevel;
						}
						$.post(Global.Server.REST, fRow, function (oData) {
							if (oData.status == "true") {
								//toastr.success("Uspe&#353;no", 'Obra&#273;eno ' + file.name, {"timeOut": "500"});
								self.set('value', fFileName);
							} else {
								toastr.error("Neuspe&#353;o", oData.message, { "timeOut": "500" });
							}
						}, "json").fail(function () { toastr.error("Error", 'Network error'); });
					};
					reader.onerror = function (error) {
						toastr.error("Neuspe&#353;o", error, { "timeOut": "500" });
						console.log('Error: ', error);
					};
				});
			});
			self.observe('rows', function (n, o) {
				//Empty				
			});
			self.observe('value', function (n, o) {
				if (typeof n !== "undefined") {
					switch (self.get('type').toLowerCase()) {
						case 'date1':
							if (self.get('value').indexOf("-") == 4) {
								var fvalue = self.get('value');
								var newvalue = fvalue.substring(8, 10) + '.' + fvalue.substring(5, 7) + '.' + fvalue.substring(0, 4);
								self.set('value', newvalue);
							}
							break;
						case 'checkbox1':
							var fchecked = false;
							var fvalue = self.get('value');

							if ((fvalue == '1') || (fvalue = 'true')) fchecked = true;

							self.set('checked', fchecked);
							break;
						case 'reference':
							if(n!=o){
								if(n){
									var RefTimeout = setTimeout(getRefVal, 400, n);
								}else{
									self.set("refvalue", '');
								}							
							}
							break;
					}
				}
			});
			self.on('doTimeHourMinShow', function () {
				/*self.set('refshow', true);
				var fId = "Reference" + self.get('id') + "Show";
				var ReferenceModal = new bootstrap.Modal(document.getElementById(fId));
				if(ReferenceModal){
					ReferenceModal.show();
					self.set('refmodal', ReferenceModal);
				}*/
			});
			self.on('doTimeHourMinSave', function () {
				/*self.set('value', self.get('valueRef'));
				self.get('refmodal').hide();*/
			});
			self.on('doReferenceShow', function () {
				self.set('refshow', true);
				var fId = "Reference" + self.get('id') + "Show";
				var ReferenceModal = new bootstrap.Modal(document.getElementById(fId));
				if(ReferenceModal){
					ReferenceModal.show();
					self.set('refmodal', ReferenceModal);

					setTimeout(function(){
            try{
              if(document.getElementById("ReferenceFindText")){
                document.getElementById("ReferenceFindText").focus();
              }
            }catch(err){
              console.log('Error:', err);
            }
        	}, 700);					
				}
			});
			self.on('doReferenceSave', function () {
				self.set('value', self.get('valueRef'));
				self.get('refmodal').hide();
			});
			self.observe('ValueDbClick', function(n,o){
				if(n){
					self.set('value', self.get('valueRef'));
					self.get('refmodal').hide();					
				}
			});
		},
		data: function () {
			return {
				id: "",
				rows: null,
				regex: '',
				valuef: '',				
				labelf: '',
				groupf: '',
				placeholder: '',
				readonly: false,
				mandatory: false,
				title: '',
				value: '',
				valueRef: undefined,
				refvalue: '',
				refshow: false,
				refmodal: undefined,
				ValueDbClick: 0,
				showTitle: true,
				type: 'text',
				style: '',
				ViewCol: '',
				msgErr: '',
				Meta: {},
				dd: false,
				styleRegex: function (iValue, iRegex) {
					if (iRegex) {
						if ((re = new RegExp(iRegex)) && (iValue)) {
							if (re.test(iValue)) {
								return '<span class="text-success">*</span>';
							} else {
								return '<span class="text-danger">*</span>';
							}
						}

						return '<span class="text-danger">*</span>';
					}

					return "";
				},
				classGroup: "form-floating mb-3",
				classInput: 'form-control',
				classLabel: 'floating-label1',
				class: 'form-control',
				classEmpty: function(iValue) {
					if (iValue) {
						return '';
					} else {
						return 'empty';
					}
				},
				classRegex: function (iValue, iRegex) {
					if (iRegex) {
						if ((re = new RegExp(iRegex)) && (iValue)) {
							if (re.test(iValue)) {
								return '';
							} else {
								return 'is-invalid';
							}
						}

						return 'is-invalid';
					}

					return "";
				}
			}
		},
		computed: {
			checked: {
				get: function () {
					var fValue = false;

					if (this.get("value") === true) {
						fValue = true;
					} else {
						fValue = ((this.get("value") == "1") || (this.get("value") == "true"));
					}

					return fValue;
				},
				set: function (v) {
					this.set("value", (v ? '1' : '0'));
				}
			},
			value_time: {
				get: function () {
					var fTime = this.get("value");

					if(fTime&&10<fTime.length) {
					 //fTime = fTime.toString().trim().replace("T", " ");
					 fTime = fTime.toString().trim().substring(11, 16);
					}
					//console.log('time.get', fTime, this.get("value"));

					return fTime;
				},
				set: function (v) { 
					v = "1900-01-01T" + ((v? v:"00:00")) + ":00";
					//console.log('time.set', v);
					this.set("value", v);
				}
			},			
			value_date: {
				get: function () {
					var fDate = this.get("value");

					if(fDate) {
					 //fDate = fDate.toString().trim().replace("T", " ");
					 fDate = fDate.toString().trim().substring(0, 10);
					}
					//console.log('date.get', fDate);

					return fDate;
				},
				set: function (v) { 
					//console.log('date.set', v);
					this.set("value", v);
				}
			},
			value_hour: {
				get: function () {
					var fValue = this.get("value");

					if(fValue) {
						var fMin = parseInt(fValue);
					 	return Math.trunc(fMin/60);
					}

					return '';
				},
				set: function (v) { 
					if(v) {
						var fMin = parseInt(this.get('value'))%60;
					 	var fValue = (v*60) + (fMin? fMin:0);
						
						this.set("value", fValue);
					}else{
						var fMin = parseInt(this.get('value'))%60;					
						this.set("value", fMin);
					}
				}
			},
			value_min: {
				get: function () {
					var fValue = this.get("value");

					if(fValue) {
						var fMin = parseInt(fValue)%60;
					 	return Math.trunc(fMin);
					}

					return 0;
				},
				set: function (v) { 
					if(v) {
						var fHour = Math.trunc(parseInt(this.get('value'))/60);
					 	var fValue = (fHour*60) + parseInt(v);
						
						this.set("value", fValue);
					}else{
						var fHour = Math.trunc(parseInt(this.get('value'))/60)*60;
						
						this.set("value", fHour);
					}
				}
			},
			selected: {
				get: function () {
					var fValue = this.get("value");
					//console.log('a.get', fValue);
					if (typeof (fValue) !== "string") return [];
					var fReturn = fValue.split(',');
					console.log('a.return', fReturn);
					return fReturn;
				},
				set: function (v) {
					console.log('v', v);
					//console.log('a.set', v, v.join());
					this.set("value", v.join());
				}
			}
		}
	}

component.exports.template = {v:4,t:[{t:4,f:[{t:4,f:[{p:[3,1,35],t:7,e:"dt",f:[{t:4,f:[{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[3,23,57]},{t:3,r:"title",p:[3,53,87]}],n:50,r:"showTitle",p:[3,5,39]}]}," ",{p:[4,1,112],t:7,e:"dd",f:[{p:[5,2,119],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[5,13,130]}],t:13},{n:"type",f:"text",t:13},{n:"class",f:"form-control empty",t:13},{n:"value",f:[{t:2,r:"value",p:[5,67,184]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[5,91,208]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[6,3,230]}]}]}],n:50,r:"dd",p:[2,1,22]},{t:4,n:51,f:[{p:[9,1,291],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[9,13,303]}," ",{t:2,r:"ViewCol",p:[9,28,318]}],t:13}],f:[{p:[10,2,334],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[10,13,345]}],t:13},{n:"type",f:"text",t:13},{n:"class",f:[{t:2,r:"classInput",p:[10,40,372]}," ",{t:2,x:{r:["classEmpty","value"],s:"_0(_1)"},p:[10,55,387]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[10,77,409]}],t:13},{n:"value",f:[{t:2,r:"value",p:[10,114,446]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[10,138,470]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[10,157,489]}]}," ",{t:4,f:[{p:[11,20,552],t:7,e:"label",m:[{n:"class",f:[{t:2,r:"classLabel",p:[11,34,566]}],t:13}],f:[{t:3,r:"title",p:[11,50,582]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[11,61,593]}]}],n:50,r:"showTitle",p:[11,2,534]}," ",{t:4,f:[{p:[12,17,656],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[12,51,690]}],t:13}],f:[{t:3,r:"msgErr",p:[12,59,698]}]}],n:50,r:"msgErr",p:[12,2,641]}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"text\""},p:[1,1,0]},{t:4,f:[{t:4,f:[{p:[18,1,793],t:7,e:"dt",f:[{t:4,f:[{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[18,23,815]},{t:3,r:"title",p:[18,53,845]}],n:50,r:"showTitle",p:[18,5,797]}]}," ",{p:[19,1,870],t:7,e:"dd",f:[{p:[20,2,877],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[20,13,888]}],t:13},{n:"type",f:"text",t:13},{n:"class",f:"form-control empty",t:13},{n:"value",f:[{t:2,r:"value",p:[20,67,942]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[20,91,966]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[21,3,988]}]}]}],n:50,r:"dd",p:[17,1,780]},{t:4,n:51,f:[{p:[24,1,1049],t:7,e:"div",m:[{n:"class",f:["form-group ",{t:2,r:"ViewCol",p:[24,24,1072]}," ",{t:4,f:["is-invalid"],n:50,r:"msgErr",p:[24,36,1084]}],t:13}],f:[{t:4,f:[{p:[25,20,1139],t:7,e:"label",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[25,49,1168]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[25,60,1179]}]}],n:50,r:"showTitle",p:[25,2,1121]}," ",{p:[26,2,1227],t:7,e:"div",m:[{n:"class",f:"input-group",t:13},{n:"role",f:"group",t:13},{n:"aria-label",f:"Reference",t:13}],f:[{p:[27,3,1292],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[27,14,1303]}],t:13},{n:"type",f:"text",t:13},{n:"class",f:[{t:2,r:"classInput",p:[27,41,1330]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[27,56,1345]}],t:13},{n:"style",f:"max-width: 90px;",t:13},{n:"value",f:[{t:2,r:"value",p:[27,117,1406]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[27,140,1429]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[27,159,1448]}]}," ",{p:[28,3,1494],t:7,e:"button",m:[{n:"class",f:"btn btn-outline-secondary",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doReferenceShow\")]"}},t:70}],f:[{p:[28,86,1577],t:7,e:"i",m:[{n:"class",f:"fa fa-dot-circle-o",t:13},{n:"aria-hidden",f:"true",t:13}]}]}," ",{p:[29,3,1643],t:7,e:"input",m:[{n:"id",f:["Ref",{t:2,r:"id",p:[29,17,1657]}],t:13},{n:"type",f:"text",t:13},{n:"class",f:[{t:2,r:"classInput",p:[29,44,1684]}],t:13},{n:"value",f:[{t:2,r:"refvalue",p:[29,66,1706]}],t:13},{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}]}]}," ",{t:4,f:[{p:[31,17,1764],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[31,51,1798]}],t:13}],f:[{t:3,r:"msgErr",p:[31,59,1806]}]}],n:50,r:"msgErr",p:[31,2,1749]}]}],l:1},{t:4,f:[{p:[35,1,1870],t:7,e:"div",m:[{n:"id",f:["Reference",{t:2,r:"id",p:[35,19,1888]},"Show"],t:13},{n:"class",f:"modal fade",t:13},{n:"data-bs-backdrop",f:"static",t:13},{n:"data-bs-keyboard",f:"false",t:13},{n:"tabindex",f:"-1",t:13},{n:"aria-labelledby",f:["Reference ",{t:3,r:"title",p:[35,143,2012]}],t:13},{n:"aria-hidden",f:"true",t:13}],f:[{p:[36,3,2048],t:7,e:"div",m:[{n:"class",f:"modal-dialog modal-xl",t:13}],f:[{p:[37,5,2089],t:7,e:"div",m:[{n:"class",f:"modal-content",t:13}],f:[{p:[38,7,2124],t:7,e:"div",m:[{n:"class",f:"modal-header",t:13}],f:[{p:[39,9,2160],t:7,e:"h5",m:[{n:"class",f:"modal-title",t:13}],f:[{t:3,r:"title",p:[39,33,2184]}]}," ",{p:[40,9,2210],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn-close",t:13},{n:"data-bs-dismiss",f:"modal",t:13},{n:"aria-label",f:"Close",t:13}]}]}," ",{p:[42,7,2324],t:7,e:"div",m:[{n:"class",f:"modal-body",t:13}],f:[{p:[43,5,2354],t:7,e:"Element-TableRef",m:[{n:"SqlId",f:[{t:2,r:"Meta.ReferenceSqlId",p:[43,29,2378]}],t:13},{n:"ValueDbClick",f:[{t:2,r:"ValueDbClick",p:[43,66,2415]}],t:13},{n:"Value",f:[{t:2,r:"value",p:[43,89,2438]}],t:13},{n:"ValueOut",f:[{t:2,r:"valueRef",p:[43,108,2457]}],t:13}]}]}," ",{p:[45,7,2511],t:7,e:"div",m:[{n:"class",f:"modal-footer",t:13}],f:[{p:[46,5,2543],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-success",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doReferenceSave\")]"}},t:70},{t:4,f:[{n:"disabled",f:0,t:13}],n:50,x:{r:["valueRef"],s:"!_0"},p:[46,92,2630]}],f:["Prihvati"]}," ",{p:[47,5,2687],t:7,e:"button",m:[{n:"type",f:"button",t:13},{n:"class",f:"btn btn-secondary",t:13},{n:"data-bs-dismiss",f:"modal",t:13}],f:["zatvori"]}]}]}]}]}],n:50,r:"refshow",p:[34,1,1852]}],n:50,x:{r:["type"],s:"_0==\"reference\""},p:[16,1,753]},{t:4,f:[{t:4,f:[{p:[56,1,2877],t:7,e:"dt",f:[{t:4,f:[{t:3,r:"title",p:[56,23,2899]}],n:50,r:"showTitle",p:[56,5,2881]}]}," ",{p:[57,1,2924],t:7,e:"dd",f:[{p:[58,2,2931],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[58,13,2942]}],t:13},{n:"type",f:"number",t:13},{n:"value",f:[{t:2,r:"value",p:[58,42,2971]}],t:13},{n:"style",f:"text-align: right;",t:13},{n:"class",f:[{t:2,r:"classInput",p:[58,87,3016]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[58,116,3045]}],t:13},{n:"data-mask",f:"",t:13}]}]}],n:50,r:"dd",p:[55,1,2864]},{t:4,n:51,f:[{p:[61,1,3096],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[61,13,3108]}," ",{t:2,r:"ViewCol",p:[61,28,3123]}," ",{t:4,f:["is-invalid"],n:50,r:"msgErr",p:[61,40,3135]}],t:13}],f:[{t:4,f:[{p:[62,20,3190],t:7,e:"label",m:[{n:"class",f:[{t:2,r:"classLabel",p:[62,34,3204]}],t:13}],f:[{t:3,r:"title",p:[62,50,3220]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[62,61,3231]}]}],n:50,r:"showTitle",p:[62,2,3172]}," ",{p:[63,2,3279],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[63,13,3290]}],t:13},{n:"type",f:"number",t:13},{n:"value",f:[{t:2,r:"value",p:[63,42,3319]}],t:13},{n:"style",f:"text-align: right;",t:13},{n:"class",f:[{t:2,r:"classInput",p:[63,87,3364]}," ",{t:2,x:{r:["classEmpty","value"],s:"_0(_1)"},p:[63,102,3379]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[63,124,3401]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[63,167,3444]}],t:13},{n:"data-mask",f:"",t:13}]}," ",{t:4,f:[{p:[64,17,3494],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[64,51,3528]}],t:13}],f:[{t:3,r:"msgErr",p:[64,59,3536]}]}],n:50,r:"msgErr",p:[64,2,3479]}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"numeric\""},p:[54,1,2839]},{t:4,f:[{p:[69,1,3614],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[69,13,3626]}," ",{t:2,r:"ViewCol",p:[69,28,3641]}," ",{t:4,f:["is-invalid"],n:50,r:"msgErr",p:[69,40,3653]}],t:13}],f:[{t:4,f:[{p:[70,20,3708],t:7,e:"label",m:[{n:"class",f:[{t:2,r:"classLabel",p:[70,34,3722]}],t:13}],f:[{t:3,r:"title",p:[70,50,3738]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[70,61,3749]}]}],n:50,r:"showTitle",p:[70,2,3690]}," ",{p:[71,2,3797],t:7,e:"input",m:[{n:"type",f:"number",t:13},{n:"value",f:[{t:2,r:"value",p:[71,30,3825]}],t:13},{n:"style",f:"text-align: right;",t:13},{n:"class",f:[{t:2,r:"classInput",p:[71,75,3870]}," ",{t:2,x:{r:["classEmpty","value"],s:"_0(_1)"},p:[71,90,3885]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[71,112,3907]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[71,155,3950]}],t:13},{n:"data-mask",f:"",t:13}]}," ",{t:4,f:[{p:[72,17,4000],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[72,51,4034]}],t:13}],f:[{t:3,r:"msgErr",p:[72,59,4042]}]}],n:50,r:"msgErr",p:[72,2,3985]}]}],n:50,x:{r:["type"],s:"_0==\"money\""},p:[68,1,3591]},{t:4,f:[{p:[76,1,4110],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[76,13,4122]}," ",{t:2,r:"ViewCol",p:[76,28,4137]}],t:13}],f:[{t:4,f:[{p:[77,20,4171],t:7,e:"label",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[77,49,4200]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[77,60,4211]}]}],n:50,r:"showTitle",p:[77,2,4153]}," ",{p:[78,2,4259],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[78,13,4270]}],t:13},{n:"type",f:[{t:2,r:"type",p:[78,27,4284]}],t:13},{n:"class",f:[{t:2,r:"classInput",p:[78,44,4301]}," ",{t:2,x:{r:["classEmpty","value"],s:"_0(_1)"},p:[78,59,4316]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[78,81,4338]}],t:13},{n:"value",f:[{t:2,r:"value_date",p:[78,118,4375]}],t:13},{n:"pattern",f:"\\d{4}-\\d{2}-\\d{2}",t:13},{n:"data-plugin",f:"datepicker",t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[78,200,4457]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[78,219,4476]}]}," ",{t:4,f:[{p:[79,17,4536],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[79,51,4570]}],t:13}],f:[{t:3,r:"msgErr",p:[79,59,4578]}]}],n:50,r:"msgErr",p:[79,2,4521]}]}],n:50,x:{r:["type"],s:"_0==\"date\""},p:[75,1,4088]},{t:4,f:[{p:[83,1,4646],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[83,13,4658]}," ",{t:2,r:"ViewCol",p:[83,28,4673]}],t:13}],f:[{t:4,f:[{p:[84,20,4707],t:7,e:"label",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[84,49,4736]}]}],n:50,r:"showTitle",p:[84,2,4689]}," ",{p:[85,2,4765],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[85,13,4776]}],t:13},{n:"type",f:[{t:2,r:"type",p:[85,27,4790]}],t:13},{n:"class",f:[{t:2,r:"classInput",p:[85,44,4807]}," ",{t:2,x:{r:["classEmpty","value"],s:"_0(_1)"},p:[85,59,4822]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[85,81,4844]}],t:13},{n:"value",f:[{t:2,r:"value_time",p:[85,118,4881]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[85,147,4910]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[85,166,4929]}]}," ",{t:4,f:[{p:[86,17,4989],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[86,51,5023]}],t:13}],f:[{t:3,r:"msgErr",p:[86,59,5031]}]}],n:50,r:"msgErr",p:[86,2,4974]}]}],n:50,x:{r:["type"],s:"_0==\"time\""},p:[82,1,4624]},{t:4,f:[{p:[90,1,5103],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[90,13,5115]}," ",{t:2,r:"ViewCol",p:[90,28,5130]}],t:13}],f:[{t:4,f:[{p:[91,20,5164],t:7,e:"label",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[91,49,5193]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[91,60,5204]}]}],n:50,r:"showTitle",p:[91,2,5146]}," ",{p:[92,2,5252],t:7,e:"input",m:[{n:"id",f:[{t:2,r:"id",p:[92,13,5263]}],t:13},{n:"type",f:"datetime-local",t:13},{n:"class",f:[{t:2,r:"classInput",p:[92,50,5300]}," ",{t:2,x:{r:["classEmpty","value"],s:"_0(_1)"},p:[92,65,5315]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[92,87,5337]}],t:13},{n:"value",f:[{t:2,r:"value",p:[92,124,5374]}],t:13},{n:"data-plugin",f:"datepicker",t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[92,173,5423]}],t:13},{t:4,f:[{n:"readonly",f:0,t:13},{n:"disabled",f:0,t:13}],n:50,r:"readonly",p:[92,192,5442]}]}," ",{t:4,f:[{p:[93,17,5502],t:7,e:"label",m:[{n:"class",f:"control-label",t:13},{n:"for",f:[{t:2,r:"id",p:[93,51,5536]}],t:13}],f:[{t:3,r:"msgErr",p:[93,59,5544]}]}],n:50,r:"msgErr",p:[93,2,5487]}]}],n:50,x:{r:["type"],s:"_0==\"datetime\""},p:[89,1,5077]},{t:4,f:[{t:4,f:[{p:[98,1,5625],t:7,e:"dt",f:[{t:4,f:[{t:3,r:"title",p:[98,23,5647]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[98,34,5658]}],n:50,r:"showTitle",p:[98,5,5629]}]}," ",{p:[99,1,5702],t:7,e:"dd",f:[{p:[100,2,5709],t:7,e:"textarea",m:[{n:"rows",f:[{t:2,r:"rows",p:[100,18,5725]}],t:13},{n:"value",f:[{t:2,r:"value",p:[100,35,5742]}],t:13},{n:"class",f:[{t:2,r:"classInput",p:[100,53,5760]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[100,68,5775]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[100,111,5818]}],t:13}]}]}],n:50,r:"dd",p:[97,1,5612]},{t:4,n:51,f:[{p:[103,1,5867],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[103,13,5879]}," ",{t:2,r:"ViewCol",p:[103,28,5894]}],t:13}],f:[{t:4,f:[{p:[104,20,5928],t:7,e:"label",m:[{n:"class",f:[{t:2,r:"classLabel",p:[104,34,5942]}],t:13}],f:[{t:3,r:"title",p:[104,50,5958]},{t:3,x:{r:["styleRegex","value","regex"],s:"_0(_1,_2)"},p:[104,61,5969]}]}],n:50,r:"showTitle",p:[104,2,5910]}," ",{p:[105,2,6017],t:7,e:"textarea",m:[{n:"rows",f:[{t:2,r:"rows",p:[105,18,6033]}],t:13},{n:"value",f:[{t:2,r:"value",p:[105,35,6050]}],t:13},{n:"class",f:[{t:2,r:"classInput",p:[105,53,6068]}," ",{t:2,x:{r:["classRegex","value","regex"],s:"_0(_1,_2)"},p:[105,68,6083]}],t:13},{n:"placeholder",f:[{t:3,r:"placeholder",p:[105,111,6126]}],t:13}]}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"memo\""},p:[96,1,5590]},{t:4,f:[{p:[110,1,6206],t:7,e:"div",m:[{n:"class",f:[{t:2,r:"classGroup",p:[110,13,6218]}," ",{t:2,r:"ViewCol",p:[110,28,6233]}],t:13}],f:[{t:4,f:[{p:[111,20,6267],t:7,e:"label",m:[{n:"class",f:[{t:2,r:"classLabel",p:[111,34,6281]}],t:13}],f:[{t:3,r:"title",p:[111,50,6297]}]}],n:50,r:"showTitle",p:[111,2,6249]}," ",{p:[112,2,6326],t:7,e:"form",m:[{n:"action",f:"/file-upload",t:13},{n:"class",f:"dropzone dropzonee",t:13},{n:"id",f:"dzone",t:13}],f:[{p:[113,3,6396],t:7,e:"div",m:[{n:"class",f:"fallback",t:13}],f:[{p:[114,4,6423],t:7,e:"input",m:[{n:"name",f:"file",t:13},{n:"type",f:"file",t:13},{n:"multiple",f:0,t:13}]}]}]}]}],n:50,x:{r:["type"],s:"_0==\"file\""},p:[109,1,6184]},{t:4,f:[{t:4,f:[{p:[121,1,6543],t:7,e:"dt",f:[{t:4,f:[{t:3,r:"title",p:[121,23,6565]}],n:50,r:"showTitle",p:[121,5,6547]}]}," ",{p:[122,1,6590],t:7,e:"dd",f:[{p:[123,2,6597],t:7,e:"div",m:[{n:"class",f:"checkbox-custom checkbox-default",t:13}],f:[{p:[124,3,6647],t:7,e:"input",m:[{n:"type",f:"checkbox",t:13},{n:"checked",f:[{t:2,r:"checked",p:[124,35,6679]}],t:13}]}]}]}],n:50,r:"dd",p:[120,1,6530]},{t:4,n:51,f:[{p:[128,1,6720],t:7,e:"div",m:[{n:"class",f:["form-group ",{t:2,r:"ViewCol",p:[128,25,6744]}],t:13}],f:[{p:[129,2,6760],t:7,e:"div",m:[{n:"class",f:"checkbox-custom checkbox-default",t:13}],f:[{p:[130,3,6810],t:7,e:"input",m:[{n:"type",f:"checkbox",t:13},{n:"checked",f:[{t:2,r:"checked",p:[130,35,6842]}],t:13}]}," ",{t:4,f:[{p:[132,3,6881],t:7,e:"label",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[132,32,6910]}]}],n:50,r:"showTitle",p:[131,3,6859]}]}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"checkbox\""},p:[119,1,6504]},{t:4,f:[{t:4,f:[{p:[140,1,7014],t:7,e:"dt",f:[{t:4,f:[{t:3,r:"title",p:[140,23,7036]}],n:50,r:"showTitle",p:[140,5,7018]}]}," ",{p:[141,1,7061],t:7,e:"dd",f:[{p:[142,2,7068],t:7,e:"div",m:[{n:"class",f:"custom-control custom-switch",t:13}],f:[{p:[143,3,7114],t:7,e:"input",m:[{n:"type",f:"checkbox",t:13},{n:"class",f:"custom-control-input js-switch-small",t:13},{n:"data-plugin",f:"switchery",t:13},{n:"data-size",f:"small",t:13},{n:"id",f:"customSwitchView",t:13},{n:"checked",f:[{t:2,r:"checked",p:[144,35,7259]}],t:13}]}]}]}],n:50,r:"dd",p:[139,1,7001]},{t:4,n:51,f:[{p:[148,1,7300],t:7,e:"div",m:[{n:"class",f:["form-group ",{t:2,r:"ViewCol",p:[148,25,7324]}],t:13}],f:[{p:[149,2,7340],t:7,e:"div",m:[{n:"class",f:"custom-control custom-switch",t:13}],f:[{p:[150,3,7386],t:7,e:"input",m:[{n:"type",f:"checkbox",t:13},{n:"class",f:"custom-control-input js-switch-small",t:13},{n:"data-plugin",f:"switchery",t:13},{n:"data-size",f:"small",t:13},{n:"id",f:"customSwitchView",t:13},{n:"checked",f:[{t:2,r:"checked",p:[151,35,7531]}],t:13}]}," ",{t:4,f:[{p:[153,3,7570],t:7,e:"label",m:[{n:"class",f:"custom-control-label",t:13},{n:"for",f:"customSwitchView",t:13}],f:[{t:3,r:"title",p:[153,62,7629]}]}],n:50,r:"showTitle",p:[152,3,7548]}]}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"switch\""},p:[138,1,6977]},{t:4,f:[{t:4,f:[{p:[161,1,7732],t:7,e:"dt",f:[{t:4,f:[{t:3,r:"title",p:[161,23,7754]}],n:50,r:"showTitle",p:[161,5,7736]}]}," ",{p:[162,1,7779],t:7,e:"dd",f:[{t:3,r:"value",p:[162,5,7783]}]}],n:50,r:"dd",p:[160,1,7719]},{t:4,n:51,f:[{t:4,f:[{p:[164,19,7829],t:7,e:"small",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[164,48,7858]}]},{p:[164,67,7877],t:7,e:"br"}],n:50,r:"showTitle",p:[164,1,7811]}," ",{p:[165,1,7890],t:7,e:"strong",m:[{n:"class",f:[{t:2,r:"classInput",p:[165,16,7905]}," ",{t:4,f:["is-invalid"],n:50,r:"regexError",p:[165,31,7920]}],t:13}],f:[{t:3,r:"value",p:[165,69,7958]}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"label\""},p:[159,1,7696]},{t:4,f:[{t:4,f:[{p:[170,1,8034],t:7,e:"dt",f:[{t:4,f:[{p:[170,23,8056],t:7,e:"label",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[170,52,8085]}]}],n:50,r:"showTitle",p:[170,5,8038]}]}," ",{p:[171,1,8118],t:7,e:"dd",f:[{p:[172,2,8125],t:7,e:"div",f:[{p:[173,3,8134],t:7,e:"img",m:[{n:"class",f:"image img img-responsive",t:13},{n:"src",f:[{t:4,f:["/img/",{t:2,r:"value",p:[174,28,8200]}],n:50,r:"value",p:[174,9,8181]},{t:4,n:51,f:["/img/default-thumbnail.jpg"],l:1}],t:13}]}," ",{t:4,f:[{p:[176,3,8274],t:7,e:"button",m:[{n:"class",f:"btn btn-xs btn-danger",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doImageDelete\")]"}},t:70}],f:["delete"]}," ",{p:[177,3,8370],t:7,e:"small",f:[{t:3,r:"value",p:[177,10,8377]}]}],n:50,r:"value",p:[175,3,8256]},{t:4,n:51,f:[{p:[179,3,8412],t:7,e:"input",m:[{t:4,f:[{n:"id",f:[{t:2,r:"id",p:[179,30,8439]}],t:13}],n:50,x:{r:["id"],s:"_0!=\"\""},p:[179,10,8419]},{n:"type",f:"file",t:13}]}],l:1}]}]}],n:50,r:"dd",p:[169,1,8021]},{t:4,n:51,f:[{t:4,f:[{p:[184,19,8526],t:7,e:"span",m:[{n:"class",f:"control-label",t:13}],f:[{t:3,r:"title",p:[184,47,8554]}]}],n:50,r:"showTitle",p:[184,1,8508]}," ",{p:[185,1,8581],t:7,e:"div",f:[{p:[186,2,8589],t:7,e:"img",m:[{n:"class",f:"image img img-responsive",t:13},{n:"src",f:[{t:4,f:["/img/",{t:2,r:"value",p:[187,27,8654]}],n:50,r:"value",p:[187,8,8635]},{t:4,n:51,f:["/img/default-thumbnail.jpg"],l:1}],t:13}]}," ",{t:4,f:[{p:[189,2,8726],t:7,e:"button",m:[{n:"class",f:"btn btn-xs btn-danger",t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doImageDelete\")]"}},t:70}],f:["delete"]}," ",{p:[190,2,8821],t:7,e:"small",f:[{t:3,r:"value",p:[190,9,8828]}]}],n:50,r:"value",p:[188,2,8709]},{t:4,n:51,f:[{p:[192,2,8861],t:7,e:"input",m:[{t:4,f:[{n:"id",f:[{t:2,r:"id",p:[192,29,8888]}],t:13}],n:50,x:{r:["id"],s:"_0!=\"\""},p:[192,9,8868]},{n:"type",f:"file",t:13}]}],l:1}]}],l:1}],n:50,x:{r:["type"],s:"_0==\"image\""},p:[168,1,7998]}],e:{"_0(_1,_2)":function (_0,_1,_2){return(_0(_1,_2));},"_0(_1)":function (_0,_1){return(_0(_1));},"_0==\"text\"":function (_0){return(_0=="text");},"[_0.fire(\"doReferenceShow\")]":function (_0){return([_0.fire("doReferenceShow")]);},"[_0.fire(\"doReferenceSave\")]":function (_0){return([_0.fire("doReferenceSave")]);},"!_0":function (_0){return(!_0);},"_0==\"reference\"":function (_0){return(_0=="reference");},"_0==\"numeric\"":function (_0){return(_0=="numeric");},"_0==\"money\"":function (_0){return(_0=="money");},"_0==\"date\"":function (_0){return(_0=="date");},"_0==\"time\"":function (_0){return(_0=="time");},"_0==\"datetime\"":function (_0){return(_0=="datetime");},"_0==\"memo\"":function (_0){return(_0=="memo");},"_0==\"file\"":function (_0){return(_0=="file");},"_0==\"checkbox\"":function (_0){return(_0=="checkbox");},"_0==\"switch\"":function (_0){return(_0=="switch");},"_0==\"label\"":function (_0){return(_0=="label");},"[_0.fire(\"doImageDelete\")]":function (_0){return([_0.fire("doImageDelete")]);},"_0!=\"\"":function (_0){return(_0!="");},"_0==\"image\"":function (_0){return(_0=="image");}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Element/Input.html
// module id = 15
// module chunks = 0